/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useTypedSelector} from "helpers/reducers";
import LanguageFlagSelector from "pages/Front/components/LanguageFlagSelector";
import CardComponent from "pages/Front/Booking/components/CardComponent";
import LanguageSelector from "pages/Front/components/LanguageSelector";
import {XMarkIcon} from "@heroicons/react/24/outline";
import {IS_DEV, languages} from "helpers/config";
import clsx from "clsx";

const LanguageNew = () => {
    const hallLanguage = useTypedSelector(state => state.hallState.hall?.language?.code);
    const language = useTypedSelector(state => state.sessionState.language?.code) || hallLanguage;

    const [languageIsActive, setLanguagePopupActive] = useState(false);
    const {t} = useTranslation();
    const handleLanguageToggle = () => {
        setLanguagePopupActive(!languageIsActive);
    };
    const isFullscreen: boolean = false;

    if (!hallLanguage) {
        return null;
    }

    return (
        <div className={"border-l border-gray-200 pl-6"}>
            <button
                className={clsx(
                    // "language-btn px-1.5 sm:px-2 w-10 sm:w-10 h-[38px] sm:h-[42px] lg:w-12 lg:h-[46px] flex items-center self-center justify-center border rounded-md hover:text-arbo-orange hover:bg-arbo-orange/5 hover:border-arbo-orange hover:shadow-sm",
                    "language-btn flex items-center self-center justify-center h-[30px] w-[30px] border-[1px]  border-[#EEEEEE] rounded-full overflow-hidden",
                    // languageIsActive ? "text-red-500 bg-red-50/50 border-red-400" : "bg-[#EEEEEE]",
                    languageIsActive ? " bg-red-50/50 border-red-400" : "bg-[#EEEEEE]",

                )}
                onClick={handleLanguageToggle}
            >
                {languageIsActive ? (
                    <span className={"flex flex-col justify-center h-full w-full text-3xl items-center"}>
                        <XMarkIcon className={"size-[24px] flex-none text-red-500"} />
                    </span>
                ) : (
                    <img alt="" className="img-language object-cover h-full w-full" src={(IS_DEV ? "https://cl.arbopark.ch" : "") + "/img/flags/flag-" + language + ".svg"} />
                )}
            </button>
            {languageIsActive && isFullscreen && (
                // <div className="isFullscreen fixed inset-0 flex flex-col bg-white z-50 h-screen p-4 sm:p-8">
                <div className="isFullscreen fixed bottom-0 flex flex-col bg-white z-50 h-screen p-4 sm:p-8">
                    <div className="flex flex-col justify-center items-center relative h-20">
                        <div className="max-w-7xl m-auto w-full">
                            <div className="flex flex-col text-center items-center justify-center">
                                <h3 className="font-normal text-black text-lg sm:text-3xl font-m">{t("Please select your language")}</h3>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col flex-grow">
                        <div className="max-w-4xl m-auto w-full">
                            <div className="LanguageFlagSelector grid grid-cols-2 mx-8 sm:grid-cols-3 gap-8 sm:gap-12">
                                {languages.map(language => (
                                    <LanguageFlagSelector
                                        key={language.id}
                                        closeLanguage={handleLanguageToggle}
                                        language={language.code}
                                        name={language.name}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {languageIsActive && !isFullscreen && (
                // <div className={"absolute right-0 sm:right-0 top-11 sm:top-12 sm:mt-0.5 lg:mt-3 z-30 min-w-[240px] w-full shadow-lg rounded-md"}>
                <div className={"absolute top-[66px] right-1 z-30 min-w-[240px] w-full shadow-lg rounded-md"}>
                    <CardComponent className={"border border-gray-200 !rounded-md !py-0.5"}>
                        <div className="flex flex-col min-w-[120px] w-full">
                            <div className="LanguageSelectors grid pag-y-3 ">
                                {languages.map(language => (
                                    <LanguageSelector
                                        key={language.id}
                                        className={" border-b border-dashed border-gray-200 last-of-type:!border-b-0 hover:!text-arbo-orange active:!text-arbo-orange !duration-75 !ease-in"}
                                        closeLanguage={handleLanguageToggle}
                                        language={language.code}
                                        name={language.name}
                                        withFlag={true}
                                    />
                                ))}
                            </div>
                        </div>
                    </CardComponent>
                </div>
            )}
        </div>
    );
};
export default LanguageNew;
